// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFlagIcon-Graphic_cls1__iyW4M","cls2":"VeloFlagIcon-Graphic_cls2__TeuSr VeloFlagIcon-Graphic_cls1__iyW4M"};